"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.codeErrorSelector = codeErrorSelector;
exports.hasCodeErrorSelector = hasCodeErrorSelector;
exports.isSubmittingSelector = isSubmittingSelector;
var _authentication = require("../../types/authentication");
function hasCodeErrorSelector(state) {
  const {
    status,
    errorType
  } = state.authentication.authenticate;
  return status === _authentication.EAuthenticateStatus.Failed && errorType !== _authentication.EAuthenticateError.TwoFactorRequired;
}
function codeErrorSelector(state) {
  if (!hasCodeErrorSelector(state)) {
    return undefined;
  }
  return state.authentication.authenticate.error;
}
function isSubmittingSelector(state) {
  const authStatus = state.authentication.authenticate.status;
  return authStatus === _authentication.EAuthenticateStatus.Loading;
}